export const ALERT_DISPLAY_TIME = 1500
export const INPUT_ERROR_TIME = 3000

export const API_LOGIN = '/api/auth/login'
export const API_SIGNUP = '/api/auth/signup'
export const API_VIDEOS = '/api/videos'
export const API_CATEGORIES = '/api/categories'
export const API_LIKES = '/api/user/likes'
export const API_WATCHLATER = '/api/user/watchlater'
export const API_PLAYLISTS = '/api/user/playlists'
export const API_HISTORY = '/api/user/history'

export const ROUTE_HOME = '/'
export const ROUTE_VIDEOS = '/videos'
export const ROUTE_LOGIN = '/login'
export const ROUTE_SIGNUP = '/signup'
export const ROUTE_HISTORY = '/history'
export const ROUTE_PLAYLISTS = '/playlists'

export const ALERT_TYPE_ERROR = 'error'
export const ALERT_TYPE_SUCCESS = 'success'

export const THEME_LIGHT = 'light'
export const THEME_DARK = 'dark'

export const ACTION_ADD_CATEGORY_TO_FILTER = 'ADD_CATEGORY_TO_FILTER'
export const ACTION_REMOVE_CATEGORY_FROM_FILTER = 'REMOVE_CATEGORY_FROM_FILTER'

export const ACTION_SET_LOADING = 'SET_LOADING'
export const ACTION_REMOVE_LOADING = 'REMOVE_LOADING'

export const ACTION_SET_ALERT = 'SET_ALERT'
export const ACTION_REMOVE_ALERT = 'REMOVE_ALERT'

export const ACTION_INIT_WATCHLATER = 'INIT_WATCHLATER'
export const ACTION_ADD_TO_WATCHLATER = 'ADD_TO_WATCHLATER'
export const ACTION_REMOVE_FROM_WATCHLATER = 'REMOVE_FROM_WATCHLATER'

export const ACTION_INIT_VIDEOS = 'INIT_VIDEOS'
export const ACTION_FILTER_VIDEOS = 'FILTER_VIDEOS'
export const ACTION_SORT_VIDEOS_LATEST = 'SORT_VIDEOS_LATEST'

export const ACTION_INIT_FORM = 'INIT_FORM'
export const ACTION_UPDATE_EMAIL = 'UPDATE_EMAIL'
export const ACTION_UPDATE_FIRST_NAME = 'UPDATE_FIRST_NAME'
export const ACTION_UPDATE_LAST_NAME = 'UPDATE_LAST_NAME'
export const ACTION_UPDATE_PASSWORD = 'UPDATE_PASSWORD'
export const ACTION_UPDATE_CONFIRMED_PASSWORD = 'UPDATE_CONFIRMED_PASSWORD'
export const ACTION_TOGGLE_PASSWORD_TYPE = 'TOGGLE_PASSWORD_TYPE'
export const ACTION_SET_EMAIL_ERROR = 'SET_EMAIL_ERROR'
export const ACTION_REMOVE_EMAIL_ERROR = 'REMOVE_EMAIL_ERROR'
export const ACTION_SET_FIRST_NAME_ERROR = 'SET_FIRST_NAME_ERROR'
export const ACTION_REMOVE_FIRST_NAME_ERROR = 'REMOVE_FIRST_NAME_ERROR'
export const ACTION_SET_LAST_NAME_ERROR = 'SET_LAST_NAME_ERROR'
export const ACTION_REMOVE_LAST_NAME_ERROR = 'REMOVE_LAST_NAME_ERROR'
export const ACTION_SET_PASSWORD_ERROR = 'SET_PASSWORD_ERROR'
export const ACTION_REMOVE_PASSWORD_ERROR = 'REMOVE_PASSWORD_ERROR'
export const ACTION_SET_CONFIRMED_PASSWORD_ERROR = 'SET_CONFIRMED_PASSWORD_ERROR'
export const ACTION_REMOVE_CONFIRMED_PASSWORD_ERROR = 'REMOVE_CONFIRMED_PASSWORD_ERROR'

export const ACTION_INIT_PLAYLISTS = 'INIT_PLAYLISTS'
export const ACTION_ADD_NEW_PLAYLIST = 'ADD_NEW_PLAYLIST'
export const ACTION_REMOVE_PLAYLIST = 'REMOVE_PLAYLIST'
export const ACTION_ADD_VIDEO_TO_PLAYLIST = 'ADD_VIDEO_TO_PLAYLIST'
export const ACTION_REMOVE_VIDEO_FROM_PLAYLIST = 'REMOVE_VIDEO_FROM_PLAYLIST'

export const ACTION_INIT_LIKES = 'INIT_LIKES'
export const ACTION_ADD_TO_LIKES = 'ADD_TO_LIKES'
export const ACTION_REMOVE_FROM_LIKES = 'REMOVE_FROM_LIKES'

export const ACTION_INIT_HISTORY = 'INIT_HISTORY'
export const ACTION_REMOVE_FROM_HISTORY = 'REMOVE_FROM_HISTORY'
export const ACTION_REMOVE_HISTORY = 'REMOVE_HISTORY'
